import config from '../config';
import request from 'superagent';
//import moment from 'moment';

class AlertService {
  getAlerts(callback) {
    //const begin = moment(moment().format("YYYY-MM-DD")).toISOString();
    //const end = moment(moment().format("YYYY-MM-DD")).add(1, 'days').toISOString();

    request
      .get(`${config.serverUrl}/alert`)
      //TODO: Check startAt / endAt, in relation to the current dates
      /* .query({
        where: JSON.stringify({
          'arriveAt': { '>=': begin, '<': end },
          'departAt': { '>=': begin, '<': end }
        })
      }) */
      .set('Content-Type', 'application/json')
      .end((err, rsp) => {
        let alerts = [];
        if (!err) {
          alerts = rsp.body;
        }

        callback.call(null, alerts);
      });
  }
}

module.exports['alertService'] = new AlertService();



// WEBPACK FOOTER //
// ./src/services/alert.js